module.exports = __webpack_public_path__ + "img/google-review.a65d16e6.jpg";